export const HOME_RECOMMENDATION_PAGE_SIZE = 20;
export const PRODUCT_ID_PREFIX = "gid://shopify/Product/";

export const Titles = {
  TOP_PICKS_FOR_YOU: "Top Picks For You",
  RECOMMENDED_FOR_YOU: "Recommended For You",
  BOUGHT_TOGETHER: "Frequently Bought Together",
  BEST_SELLING: "Valued from Bestsellings",
  FREQUENTLY_BOUGHT: "Frequently Bought Items",
  FRESH_FOOD: "Fresh food recommendations",
  BRANDS: "Brand recommendations",
  CATEGORY: "Category recommendations",
};

export const DEFAULT_PAYLOAD = {
  page: 1,
  size: HOME_RECOMMENDATION_PAGE_SIZE,
  diversifyResults: false,
  readOnlyMode: false,
};

export const DEFAULT_RECOMMENDATION = {
  products: [],
  recommendationType: "",
  totalCount: 0,
  algorithm: "",
  personalised: false,
  recommendationVariant: "",
};

export const COLORS = {
  gray: "#D4D4D8",
  yellow: "#FBF3D5",
  Gray97:"#f7f7f7"
};

export const PRODUCT_COUNT = 10;
export const BASE_CARD_WIDTH_NORMAL = 208;
export const BASE_CARD_WIDTH_COMPACT = 132;
export const MOBILE_STANDARD_WIDTH = 460;
